import PropTypes from 'prop-types';
import classes from './borrowerDetailsTable.module.css';
import FirstBorrowerIcon from '@/assets/images/firstBorrower.svg?react'; // eslint-disable-line import/no-unresolved
import SecondBorrowerIcon from '@/assets/images/secondBorrower.svg?react';// eslint-disable-line import/no-unresolved
import ThirdBorrowerIcon from '@/assets/images/thirdBorrower.svg?react';// eslint-disable-line import/no-unresolved

const BorrowerDetailsTable = ({ borrowers }) => {
  const borrowerIcons = [FirstBorrowerIcon, SecondBorrowerIcon, ThirdBorrowerIcon];

  return (
    <div className={classes.tableContainer}>
      <div className={classes.tableHeader}>
        <div className={classes.headerCell}></div> {/* Avatar column */}
        <div className={classes.headerCell}>שם מלא של הלווה</div>
        <div className={classes.headerCell}>מספר ת.ז</div>
        <div className={classes.headerCell}>מספר טלפון</div>
        <div className={classes.headerCell}>אימייל</div>
      </div>

      {borrowers.map((borrower, index) => {
        const BorrowerIcon = borrowerIcons[index] || FirstBorrowerIcon;
        return (
          <div key={borrower.idNumber} className={classes.tableRow}>
            <div className={classes.avatarCell}>
              <BorrowerIcon className={classes.avatar} />
            </div>
            <div className={classes.dataCell}>{borrower.fullName}</div>
            <div className={classes.dataCell}>{borrower.idNumber}</div>
            <div className={classes.dataCell}>{borrower.phoneNumber || 'לא צוין'}</div>
            <div className={classes.dataCell}>{borrower.email || 'לא צוין'}</div>
          </div>
        );
      })}
    </div>
  );
};

BorrowerDetailsTable.propTypes = {
  borrowers: PropTypes.arrayOf(
    PropTypes.shape({
      fullName: PropTypes.string.isRequired,
      idNumber: PropTypes.string.isRequired,
      phoneNumber: PropTypes.string,
      email: PropTypes.string,
    }),
  ).isRequired,
};

export default BorrowerDetailsTable;
